import type { OccasionPageModelProps } from '@/components/occasion/occasion-page/occasion-page.model'
import { useOccasionPageModel } from '@/components/occasion/occasion-page/occasion-page.model'
import { OccasionPageView } from '@/components/occasion/occasion-page/occasion-page.view'

export function OccasionPageViewModel(props: OccasionPageModelProps) {
  const model = useOccasionPageModel(props)
  return <OccasionPageView {...model} />
}
